/* eslint-disable max-len */
import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const PhoneIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9.92219 16.0897"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { title ? <title>{ title }</title> : null }

      <g>
        <rect height="16.0897" opacity="0" width="9.92219" x="0" y="0"/>
        <path d="M2.14617 15.1141C1.36102 15.1141 0.96719 14.7335 0.96719 13.9753L0.96719 2.10602C0.96719 1.34781 1.36102 0.964768 2.14617 0.964768L7.37516 0.964768C8.15492 0.964768 8.54875 1.34781 8.54875 2.10602L8.54875 13.9753C8.54875 14.7335 8.15492 15.1141 7.37516 15.1141Z" fill={ color } fillOpacity="0.2125"/>
        <path d="M2.03055 16.0789L7.48539 16.0789C8.74188 16.0789 9.51594 15.3294 9.51594 14.1082L9.51594 1.9707C9.51594 0.749532 8.74188 0 7.48539 0L2.03055 0C0.771641 0 0 0.749532 0 1.9707L0 14.1082C0 15.3294 0.771641 16.0789 2.03055 16.0789ZM2.14617 15.1141C1.36102 15.1141 0.96719 14.7335 0.96719 13.9753L0.96719 2.10602C0.96719 1.34781 1.36102 0.964768 2.14617 0.964768L7.37516 0.964768C8.15492 0.964768 8.54875 1.34781 8.54875 2.10602L8.54875 13.9753C8.54875 14.7335 8.15492 15.1141 7.37516 15.1141ZM3.14195 14.568L6.38477 14.568C6.5618 14.568 6.68844 14.439 6.68844 14.2566C6.68844 14.0766 6.5618 13.9529 6.38477 13.9529L3.14195 13.9529C2.96492 13.9529 2.83047 14.0766 2.83047 14.2566C2.83047 14.439 2.96492 14.568 3.14195 14.568ZM3.84805 2.39821L5.67328 2.39821C5.93438 2.39821 6.13539 2.19719 6.13539 1.93071C6.13539 1.66719 5.93438 1.4686 5.67328 1.4686L3.84805 1.4686C3.58156 1.4686 3.38055 1.66719 3.38055 1.93071C3.38055 2.19719 3.58156 2.39821 3.84805 2.39821Z" fill={ color } />
      </g>
    </svg>
  );
});
